import { env } from 'env';

export const getV1OriginUrl = () =>
  env.REACT_APP_V1_URL_LOCAL || env.REACT_APP_V1_URL;
